import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider, ThemeProvider, ToastProvider } from './hoc';
import { JobDescriptionPage } from './pages/job-description';
function JdApp(_a) {
    var theme = _a.theme, config = _a.config, _b = _a.isPreview, isPreview = _b === void 0 ? false : _b;
    return (_jsx(ThemeProvider, { theme: theme, children: _jsx(ConfigProvider, { config: config, children: _jsx(ToastProvider, { children: _jsx(JobDescriptionPage, { isPreview: isPreview }) }) }) }));
}
export default JdApp;
